// extracted by mini-css-extract-plugin
export default {"mainContainer":"navbarComponent_mainContainer__LoPgr","switch":"navbarComponent_switch__15zrP","slider":"navbarComponent_slider__Mg5xL"};